import { FACETED_SEARCH_RECEIVE } from '../constants';
import { CART_SHOW_INFO } from '../constants';
import { dataLayerGtmViewCart, pushEcommerce } from '../Services/Gtm.service';

export const gtmMiddleware = ({ getState }) => (next) => (action) => {
  const { type, payload } = action;
  try {
    switch (type) {
      case CART_SHOW_INFO:
        if (payload.showInfo) {
          gtmShowMiniCart(getState().cart);
        }
        break;
      case FACETED_SEARCH_RECEIVE:
        if (
          payload.hasOwnProperty('gtmViewModel') &&
          payload.gtmViewModel !== null
        ) {
          pushEcommerce(payload.gtmViewModel);
        }
        break;
      default:
        break;
    }
  } catch (err) {
    console.warn(err);
  }
  next(action);
};

const gtmShowMiniCart = ({ orderRows, gtmGrandTotal }) => {
  let currency = '';
  let gtmOrderRows = [];
  orderRows.forEach((row) => {
    if (row.gtmEcommerceItem) {
      row.gtmEcommerceItem.index = gtmOrderRows.length;
      gtmOrderRows.push(row.gtmEcommerceItem);

      currency = row.gtmEcommerceItem.currency;
    }
  });

  if (gtmOrderRows.length > 0) {
    dataLayerGtmViewCart({ currency, gtmGrandTotal, gtmOrderRows });
  }
};
